import type { ReceiptAssets } from "@astroplanet/shared";
import logoMono from "../assets/brand/logo-mono.png?inline";
import latin400 from "@fontsource/cairo/files/cairo-latin-400-normal.woff2?url";
import latin700 from "@fontsource/cairo/files/cairo-latin-700-normal.woff2?url";
import arabic400 from "@fontsource/cairo/files/cairo-arabic-400-normal.woff2?url";
import arabic700 from "@fontsource/cairo/files/cairo-arabic-700-normal.woff2?url";

const LATIN = "U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD";
const ARABIC = "U+0600-06FF,U+0750-077F,U+0870-088E,U+0890-0891,U+0898-08E1,U+08E3-08FF,U+200C-200E,U+2010-2011,U+204F,U+2E41,U+FB50-FDFF,U+FE70-FE74,U+FE76-FEFC";

/**
 * Fonts and logo for the live receipt preview: the same Cairo font the printer's renderer uses, so Arabic shapes identically.
 * (The preview is an iframe: it does not inherit the page's fonts, so they are declared again with absolute URLs.)
 */
export function previewAssets(): ReceiptAssets {
  const abs = (u: string) => (u.startsWith("data:") ? u : new URL(u, document.baseURI).href);
  const face = (url: string, weight: number, range: string) => `@font-face{font-family:"Cairo";font-weight:${weight};src:url(${abs(url)}) format("woff2");unicode-range:${range}}`;
  return { fontCss: [face(latin400, 400, LATIN), face(latin700, 700, LATIN), face(arabic400, 400, ARABIC), face(arabic700, 700, ARABIC)].join("\n"), logoUri: logoMono };
}
